import { Link } from "react-router-dom";
import { getCardHref, loadStoredBrandConfig } from "../config/brand.js";
import { coronaServices } from "../content/coronaServices.js";
import { LOCAL_BUSINESS } from "../config/seo.js";

export default function PageFooter() {
  const brand = loadStoredBrandConfig();
  const year = new Date().getFullYear();

  return (
    <footer className="page-footer">
      <div className="page-footer__inner">
        <section className="page-footer__brand" aria-label="Company">
          <Link className="page-footer__logo" to="/">
            {brand.identity.shortName}
          </Link>
          <p>{brand.identity.footerNote}</p>
          <address className="page-footer__nap">
            <span className="page-footer__nap-name">{LOCAL_BUSINESS.name}</span>
            {LOCAL_BUSINESS.streetAddress}
            <br />
            {LOCAL_BUSINESS.addressLocality}, {LOCAL_BUSINESS.addressRegion}{" "}
            {LOCAL_BUSINESS.postalCode}
            <br />
            <a href={`tel:${LOCAL_BUSINESS.telephone}`}>
              {LOCAL_BUSINESS.phoneDisplay}
            </a>
          </address>
        </section>

        <nav className="page-footer__nav" aria-label="Footer">
          <div className="page-footer__group">
            <h2>Site</h2>
            <Link to="/">Home</Link>
            <Link to="/pricing">Pricing</Link>
            <Link to="/markets">Markets</Link>
            <Link to="/contact">Contact</Link>
          </div>

          <div className="page-footer__group">
            <h2>Services</h2>
            {brand.featureCards.slice(0, 4).map((card, index) => (
              <Link key={card.slug ?? index} to={getCardHref(card)}>
                {card.title}
              </Link>
            ))}
          </div>

          <div className="page-footer__group">
            <h2>Corona, CA services</h2>
            {coronaServices.map((svc) => (
              <Link key={svc.slug} to={`/services/${svc.slug}`}>
                {svc.h1.replace(" in Corona, CA", "")}
              </Link>
            ))}
          </div>

          <div className="page-footer__group">
            <h2>Trust</h2>
            <Link to="/contracts">Contract templates</Link>
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms &amp; Conditions</Link>
            <Link to="/contact">Start a project</Link>
          </div>
        </nav>

        <div className="page-footer__sms" aria-label="SMS messaging">
          <h2>SMS updates</h2>
          <p>
            Text <strong>START</strong> or <strong>YES</strong> to{" "}
            <a href={`tel:${LOCAL_BUSINESS.telephone}`}>
              {LOCAL_BUSINESS.phoneDisplay}
            </a>
            , or check the SMS consent box on our{" "}
            <Link to="/contact">Contact form</Link>, to receive customer-service
            text messages about your inquiry — appointments, support, and lead
            follow-up. Message frequency varies. Message and data rates may apply.
            Reply <strong>STOP</strong> to opt out or <strong>HELP</strong> for
            help. See our <Link to="/privacy">Privacy Policy</Link> and{" "}
            <Link to="/terms">Terms &amp; Conditions</Link>.
          </p>
        </div>

        <div className="page-footer__bottom">
          <span>© {year} {brand.identity.name}</span>
          <span className="page-footer__legal">
            <Link to="/privacy">Privacy</Link>
            {" · "}
            <Link to="/terms">Terms</Link>
            {" · "}
            <Link to="/contact">Get in touch</Link>
          </span>
        </div>
      </div>
    </footer>
  );
}
